<template>
  <b-loading :active="active" :is-full-page="false" animation="none" class="is-relative" style="height: 48px; background: none" />
</template>
<script>
export default {
  props: {
    active: Boolean
  }
}
</script>